import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth.component';
import{sharedModule} from '../../../shared/share.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../auth/UserDetails/user.service';
import { UserProfile } from '../auth/UserDetails/user.profile';
import { httpInterceptorProviders } from '../../../core/Interceptor';
import { forgotpasswordComponent } from '../auth/forgotpassword/forgotpassword.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import { OtpComponent } from './otp/otp.component';
import { NgxOtpInputModule } from "ngx-otp-input";
import { ConfirmpasswordComponent } from './confirmpassword/confirmpassword.component';
import { AlertComponent } from './alert/alert.component';
import { DoctorLoginComponent } from './doctor-login/doctor-login.component';
import { DoctorRegisterComponent } from './doctor-register/doctor-register.component';
import { DoctorForgotpageComponent } from '../auth/doctor-forgotpage/doctor-forgotpage.component';
import { PatientRoutingModule } from 'src/app/module/patient/patient-routing.module';
import { ClinicLoginComponent } from './clinic-login/clinic-login.component';
import { ClinicRegisterComponent } from './clinic-register/clinic-register.component';
import { HospitalLoginComponent } from './hospital-login/hospital-login.component';
import { HospitalRegisterComponent } from './hospital-register/hospital-register.component';
import { SpecialityHospitalLoginComponent } from './speciality-hospital-login/speciality-hospital-login.component';
import { SpecialityHospitalRegisterComponent } from './speciality-hospital-register/speciality-hospital-register.component';
import { HomecareLoginComponent } from './homecare-login/homecare-login.component';
import { HomecareRegisterComponent } from './homecare-register/homecare-register.component';
import { PharmacyLoginComponent } from './pharmacy-login/pharmacy-login.component';
import { PharmacyRegisterComponent } from './pharmacy-register/pharmacy-register.component';
import { DiagnosticLabLoginComponent } from './diagnostic-lab-login/diagnostic-lab-login.component';
import { DiagnosticLabRegisterComponent } from './diagnostic-lab-register/diagnostic-lab-register.component';
import { OtpboxComponent } from './otpbox/otpbox.component';
import { PatientRegisterOtpComponent } from './register/patient-register-otp/patient-register-otp.component';
import { DoctorRegisterOtpComponent } from './doctor-register/doctor-register-otp/doctor-register-otp.component';
import { ClinicRegisterOtpComponent } from './clinic-register/clinic-register-otp/clinic-register-otp.component';
import { HospitalRegisterOtpComponent } from './hospital-register/hospital-register-otp/hospital-register-otp.component';
import { SpecialityHospitalRegisterOtpComponent } from './speciality-hospital-register/speciality-hospital-register-otp/speciality-hospital-register-otp.component';
import { PharmacyRegisterOtpComponent } from './pharmacy-register/pharmacy-register-otp/pharmacy-register-otp.component';
import { DiagnosticLabRegisterOtpComponent } from './diagnostic-lab-register/diagnostic-lab-register-otp/diagnostic-lab-register-otp.component';
import { WellnessLoginComponent } from './wellness-login/wellness-login.component';
import { WellnessRegisterComponent } from './wellness-register/wellness-register.component';
import { WellnessRegisterOtpComponent } from './wellness-register/wellness-register-otp/wellness-register-otp.component';
import { HomecareRegisterOtpComponent } from './homecare-register/homecare-register-otp/homecare-register-otp.component';
import { DoctorForgotpasswordComponent } from './doctor-forgotpassword/doctor-forgotpassword.component';
import { DoctorOtpComponent } from './doctor-otp/doctor-otp.component';
import { DoctorConfirmpasswordComponent } from './doctor-confirmpassword/doctor-confirmpassword.component';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'register',
        component: RegisterComponent
      },
      {
        path: 'forgot',
        component: forgotpasswordComponent
      },
      {
        path: 'otp',
        component: OtpComponent
      },
      {
        path: 'otpbox',
        component: OtpboxComponent
      },
      {
        path: 'confirm',
        component: ConfirmpasswordComponent
      },
      {
        path: 'doctor-otp',
        component: DoctorOtpComponent
      },
      {
        path: 'doctor-confirmpassword',
        component: DoctorConfirmpasswordComponent
      },
      {
        path: 'doctor-forgotpassword',
        component: DoctorForgotpasswordComponent
      },
      {
        path: 'login-doctor',
        component:DoctorLoginComponent
      },
      {
        path: 'register-doctor',
        component: DoctorRegisterComponent
      },
      {
        path: 'forgot-doctor',
        component: DoctorForgotpageComponent
      },
      {
        path: 'login-clinic',
        component:ClinicLoginComponent
      },
      {
        path: 'register-clinic',
        component: ClinicRegisterComponent
      },
      {
        path: 'login-hospital',
        component:HospitalLoginComponent
      },
      {
        path: 'register-hospital',
        component: HospitalRegisterComponent
      },
      {
        path: 'login-speciality-hospital',
        component:SpecialityHospitalLoginComponent
      },
      {
        path: 'register-speciality-hospital',
        component:SpecialityHospitalRegisterComponent
      },
      {
        path: 'login-homecare',
        component:HomecareLoginComponent
      },
      {
        path: 'register-homecare',
        component:HomecareRegisterComponent
      },
      {
        path: 'login-pharmacy',
        component:PharmacyLoginComponent
      },
      {
        path: 'register-pharmacy',
        component:PharmacyRegisterComponent
      },
      {
        path: 'login-diagnostic-lab',
        component:DiagnosticLabLoginComponent
      },
      {
        path: 'register-diagnostic-lab',
        component:DiagnosticLabRegisterComponent
      },
      {
        path: 'login-wellness',
        component:WellnessLoginComponent
      },
      {
        path: 'register-wellness',
        component:WellnessRegisterComponent
      }
    ]
  },
]
@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [LoginComponent, RegisterComponent, AuthComponent,forgotpasswordComponent, 
    OtpComponent, ConfirmpasswordComponent, AlertComponent, DoctorLoginComponent, 
    DoctorRegisterComponent, DoctorForgotpageComponent, ClinicLoginComponent, 
    ClinicRegisterComponent, HospitalLoginComponent, HospitalRegisterComponent, SpecialityHospitalLoginComponent, SpecialityHospitalRegisterComponent,
     HomecareLoginComponent,
     HomecareRegisterComponent,
     PharmacyLoginComponent,
     PharmacyRegisterComponent,
     DiagnosticLabLoginComponent,
     DiagnosticLabRegisterComponent,
     OtpboxComponent,
     PatientRegisterOtpComponent,
     DoctorRegisterOtpComponent,
     ClinicRegisterOtpComponent,
     HospitalRegisterOtpComponent,
     SpecialityHospitalRegisterOtpComponent,
     PharmacyRegisterOtpComponent,
     DiagnosticLabRegisterOtpComponent,
     WellnessLoginComponent,
     WellnessRegisterComponent,
     WellnessRegisterOtpComponent,
     HomecareRegisterOtpComponent,
     DoctorForgotpasswordComponent,
     DoctorOtpComponent,
     DoctorConfirmpasswordComponent],
  imports: [
    FormsModule, ReactiveFormsModule,
    CommonModule,
    sharedModule,
    MatFormFieldModule,
    NgxOtpInputModule,
    RouterModule.forChild(routes),
    PatientRoutingModule
  ], providers: [AuthService, httpInterceptorProviders]
})
export class AuthModule { }
